import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import QuestionAPIs from '../../db/question/index';
import { mapPaginatedQuestions, mapQuestionToNode } from './utils';
export const epQuestionQueries = {
    async ep_questionDetails(_, { questionID }, context) {
        const result = await QuestionAPIs.getByID(getCurrentUserID(), questionID);
        return mapQuestionToNode(result);
    },
    async ep_questionListForQP(_, { pagination, questionPaperID }, context) {
        const result = await QuestionAPIs.getList(getCurrentUserID(), questionPaperID, pagination);
        return mapPaginatedQuestions(result);
    },
    async ep_questionListForTopic(_, { ancestorID, pagination, topic }, context) {
        const result = await QuestionAPIs.getListForTopic(getCurrentUserID(), topic, ancestorID, pagination);
        return mapPaginatedQuestions(result);
    },
    async ep_questionTopicList(_, { ancestorID }, context) {
        return await QuestionAPIs.getTopicList(getCurrentUserID(), ancestorID);
    },
    async ep_questionSearch(_, { query, qpStartDate, qpEndDate, answered, read, bookmarked, includeDuplicates, sortBy, ancestorID, pagination }, context) {
        const result = await QuestionAPIs.search(getCurrentUserID(), { query, qpStartDate, qpEndDate, answered, read, bookmarked, includeDuplicates, sortBy, ancestorID }, pagination);
        return mapPaginatedQuestions(result);
    },
    async ep_questionPlaylistForQP(_, { questionPaperID }, context) {
        return await epQuestionQueries.ep_questionListForQP(_, { pagination: { offset: 0 }, questionPaperID }, context);
    },
    async ep_questionPlaylistForTopic(_, { topic, ancestorID }, context) {
        return await epQuestionQueries.ep_questionListForTopic(_, { ancestorID, pagination: { offset: 0 }, topic }, context);
    },
};
